export default __webpack_public_path__ + "static/media/yumme_deliverylocations.e1d63010.png";